import { render, staticRenderFns } from "./BurialDetails.vue?vue&type=template&id=e5971c20"
import script from "./BurialDetails.vue?vue&type=script&lang=js"
export * from "./BurialDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports